
const TikTokIcon = ({ className = "", size = 24 }: { className?: string; size?: number }) => (
  <svg 
    className={className}
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 014.1-4.08V9.94a6.33 6.33 0 00-4.61 1.83 6.33 6.33 0 008.94 8.94 6.33 6.33 0 001.83-4.61V8.73a8.89 8.89 0 005.24 1.71V6.69z"/>
  </svg>
);

export default TikTokIcon;
